export const convertArrayToApiFormat = (values: Record<string, any>) => {
  const convertedValues: Record<string, unknown> = {};

  for (const key in values) {
    if (Array.isArray(values[key])) convertedValues[key] = values[key].join(';');
  }

  return { ...values, ...convertedValues };
};
